module.exports = __webpack_public_path__ + "images/bullets---acc66fce35a54d815a3aa3fd573cdd90.png";


//////////////////
// WEBPACK FOOTER
// ./src/vendor/style/img/bullets.png
// module id = 397
// module chunks = 0